var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteLikeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.61165 7.27832L7.27832 1.27832C7.80875 1.27832 8.31746 1.48903 8.69253 1.86411C9.06761 2.23918 9.27832 2.74789 9.27832 3.27832V5.94499H13.0517C13.2449 5.9428 13.4364 5.98266 13.6127 6.0618C13.789 6.14094 13.9461 6.25748 14.0729 6.40333C14.1997 6.54918 14.2933 6.72087 14.3472 6.90649C14.4011 7.09211 14.414 7.28722 14.385 7.47832L13.465 13.4783C13.4168 13.7963 13.2553 14.0861 13.0103 14.2943C12.7652 14.5026 12.4532 14.6153 12.1317 14.6117H4.61165M4.61165 7.27832V14.6117M4.61165 7.27832H2.61165C2.25803 7.27832 1.91889 7.4188 1.66884 7.66885C1.4188 7.91889 1.27832 8.25803 1.27832 8.61165V13.2783C1.27832 13.6319 1.4188 13.9711 1.66884 14.2211C1.91889 14.4712 2.25803 14.6117 2.61165 14.6117H4.61165",
    stroke: "#FCFCFD",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLikeIcon);
export default __webpack_public_path__ + "static/media/white_like_icon.806288be7b852f8b5dfe7d21d8aad9d5.svg";
export { ForwardRef as ReactComponent };